import React from "react";
import { Constant } from "../../helper/constant";
import { httpClient } from "../../helper/utils";

/**
 * @param {string} productId
 * @param {Omit<RequestInit, "method" | "headers">} [requestInit]
 */
export async function getProductSupplierHistory(productId, requestInit) {
  const token = localStorage.getItem("token")
  const response = await httpClient(
    `${Constant.BASE_API_URL}/history_product_supplier/${productId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      ...requestInit,
    }
  );
  return response.json();
}

export function useProductSupplierHistory(productId, shouldFetch = true) {
  const [data, setData] = React.useState([])
  const [pagination, setPagination] = React.useState({
    page: 1,
    totalData: 0,
    totalPage: 1,
  })
  const [isLoading, setIsLoading] = React.useState(false)
  const [isError, setIsError] = React.useState(false)

  const fetchData = React.useCallback(async () => {
    setIsLoading(true)
    try {
      const response = await getProductSupplierHistory(productId)
      setData(response.data.history_product_supplier)
      setPagination({
        page: response.data.meta.page,
        totalData: response.data.meta.total_data,
        totalPage: response.data.meta.total_page,
      })
    } catch (err) {
      setData([])
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }, [productId])

  React.useEffect(() => {
    if (!shouldFetch) {
      return
    }
    fetchData()
  }, [fetchData, shouldFetch])

  const nextPage = React.useCallback(() => {
    setPagination((prev) => ({
      ...prev,
      page: Math.min(prev + 1, pagination.totalPage),
    }))
  }, [pagination.totalPage])

  const previousPage = React.useCallback(() => {
    setPagination((prev) => ({
      ...prev,
      page: Math.max(prev - 1, 1),
    }))
  }, [])

  const isNextPageActive = pagination.page < pagination.totalPage
  const isPreviousPageActive = pagination.page > 1

  return {
    data,
    pagination,
    isLoading,
    isError,
    isNextPageActive,
    isPreviousPageActive,
    nextPage,
    previousPage,
  }
}